import { Stack } from "@mui/material";
import { Message } from "components/Message";
import { useMemo } from "react";
import { formatFileSize } from "utils/general";
import { cn } from "utils/styling";
import { percent } from "utils/textSymbols";

import { UploadStatus } from "../model/types";
import { StatusIndicator } from "./StatusIndicator";

type FileUploadRowProps = {
  fileSize?: null | number;
  indicatorWidthClassName?: string;
  showPercentage?: boolean;
  step: { errorMessage?: string; name: string; percentage?: number; status: UploadStatus };
};

export const FileUploadRow = ({ fileSize, indicatorWidthClassName, showPercentage, step }: FileUploadRowProps) => {
  const percentageTextColor =
    !!step?.percentage && step?.percentage < 50 ? "text-lds-foreground-secondary" : "text-lds-element-primary-on";

  const hasName = !!step.name;

  const uploadSublabel = useMemo(() => {
    if (step.percentage == null || fileSize == null) return undefined;
    const uploadedBytes = Math.round((fileSize * step.percentage) / 100);
    return `${formatFileSize(uploadedBytes)} / ${formatFileSize(fileSize)}`;
  }, [step.percentage, fileSize]);

  return (
    <div className="w-full">
      <Stack className={cn("h-7 w-full", hasName && "justify-between gap-8")}>
        {hasName && (
          <span className="flex-1 truncate text-left font-ds-body-semibold-sm">
            <span>{step.name}</span>
          </span>
        )}
        <Stack className={cn("relative w-2/5 justify-end", indicatorWidthClassName)}>
          <StatusIndicator className="h-5 w-5" mode="linear" step={step} />
          {showPercentage && (
            <span
              className={cn(
                "absolute left-1/2 top-1/2  -translate-x-1/2 -translate-y-1/2  font-ds-body-regular-xs ",
                percentageTextColor
              )}
            >
              {step.percentage}
              {percent}
            </span>
          )}
        </Stack>
      </Stack>
      {uploadSublabel && <p className="text-lds-foreground-muted font-ds-body-regular-xs">{uploadSublabel}</p>}
      {step.errorMessage && <Message className="" message={step.errorMessage} variant="error" />}
    </div>
  );
};
